//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TariffRentalDTO } from 'src/app/core/models/system/tariff/tariff-rental.dto';

@Injectable({ providedIn: 'root' })

export class TariffsRentalService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TariffRentalDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.TariffsRental +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TariffRentalDTO[]>(environment.eSimApi +
                                                           eSimApiPaths.TariffsRental + "/" +
                                                           eSimApiPaths.TariffsRentalGetTariffsRental)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(tariffRental: TariffRentalDTO) {
    return {id: tariffRental.id, description: tariffRental.tariffName};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
  
  public post(tariffRental: TariffRentalDTO): Observable<TariffRentalDTO> {
    try {
      //JSON.stringify(tariffRental)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(tariffRental))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.TariffsRental +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(tariffRental: TariffRentalDTO): Observable<TariffRentalDTO> {
    try {
      //JSON.stringify(tariffRental)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(tariffRental))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TariffsRental +
                                                              "?id=" + tariffRental.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(tariffRental: TariffRentalDTO): Observable<any> {
    try {
      //JSON.stringify(tariffRental);

      if (tariffRental.id && <number>tariffRental.id>0)
        return this.put(tariffRental);
      
      return this.post(tariffRental);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
